export const ON_LOGIN_WITH_EMAIL_REQUEST = 'ON_LOGIN_WITH_EMAIL_REQUEST';
export const ON_LOGIN_WITH_EMAIL_SUCCESS = 'ON_LOGIN_WITH_EMAIL_SUCCESS';
export const ON_LOGIN_WITH_EMAIL_FAILED = 'ON_LOGIN_WITH_EMAIL_FAILED';

export const ON_LOGOUT_REQUEST = 'ON_LOGOUT_REQUEST';
export const ON_LOGOUT_SUCCESS = 'ON_LOGOUT_SUCCESS';
export const ON_LOGOUT_FAILURE = 'ON_LOGOUT_FAILURE';
